/* ag-p30-finder: year/size FILTERS, identity-safe matching, empty-state,
   brand rail outside the scroller (2026-09-30 round 4). */
(function () {
  'use strict';

  var YEAR_RE = /^(20(1[0-9]|2[0-9]|30))$/;
  var WA = 'https://wa.me/917800111678';
  var QUAL = {
    n: 1, ev: 1, classic: 1, neo: 1, plus: 1, pro: 1, max: 1,
    legender: 1, facelift: 1, old: 1, brezza: 1
  };
  var PHRASE = [
    [/\bxuv\s*[\-–]?\s*700\b/g, 'xuv700'],
    [/\bxuv\s*[\-–]?\s*300\b/g, 'xuv300'],
    [/\bxuv\s*[\-–]?\s*400\b/g, 'xuv400'],
    [/\bxuv\s*[\-–]?\s*3xo\b/g, 'xuv3xo'],
    [/\bxuv\s*[\-–]?\s*7xo\b/g, 'xuv7xo'],
    [/\bcretta\b/g, 'creta'],
    [/\bnexn\b/g, 'nexon'],
    [/\bscorpion\b/g, 'scorpio']
  ];

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9.]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(s) { return norm(s).replace(/ /g, ''); }

  function applyPhrases(s) {
    var out = ' ' + norm(s) + ' ';
    var i;
    for (i = 0; i < PHRASE.length; i++) out = out.replace(PHRASE[i][0], ' ' + PHRASE[i][1] + ' ');
    return out.replace(/\s+/g, ' ').trim();
  }

  function dl(a, b) {
    if (a === b) return 0;
    var al = a.length, bl = b.length;
    if (!al) return bl;
    if (!bl) return al;
    if (Math.abs(al - bl) > 2) return 3;
    var d = new Array(al + 1);
    var i, j;
    for (i = 0; i <= al; i++) {
      d[i] = new Array(bl + 1);
      d[i][0] = i;
    }
    for (j = 0; j <= bl; j++) d[0][j] = j;
    for (i = 1; i <= al; i++) {
      for (j = 1; j <= bl; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
        }
      }
    }
    return d[al][bl];
  }

  function maxDist(tok) {
    if (tok.length >= 8) return 2;
    if (tok.length >= 4) return 1;
    return 0;
  }

  function isIdentity(tok) {
    if (!tok) return false;
    if (/\d/.test(tok)) return true;
    return !!QUAL[tok];
  }

  function isFuzzyable(tok) {
    return /^[a-z]+$/.test(tok) && tok.length >= 4 && !QUAL[tok];
  }

  function parseQuery(q) {
    var sizes = [];
    // Preserve model integers. Units are explicit; decimals are resolved only
    // after a model with sized guards has been identified.
    var text = String(q || '').replace(/(\d{1,2}(?:\.\d{1,2})?)\s*(?:inches\b|inch\b|in\b|[″"”])/ig, function (_, size) {
      sizes.push(size);
      return ' ';
    });
    var raw = applyPhrases(text);
    var modelLabel = text.replace(/\b20(?:1[0-9]|2[0-9]|30)\b/g, ' ').replace(/\b\d+\.\d+\b/g, ' ').replace(/\s+/g, ' ').trim();
    var years = [], words = [], decimals = [];
    raw.split(' ').filter(Boolean).forEach(function (tok) {
      if (YEAR_RE.test(tok)) years.push(tok);
      else if (/^\d+\.\d+$/.test(tok)) decimals.push(tok);
      else words.push(tok);
    });
    return { raw: raw, compact: compact(raw), years: years, sizes: sizes,
      decimals: decimals, words: words, modelLabel: modelLabel, typed: String(q || '').trim() };
  }

  function hayWords(item) {
    return (item.k || '').split(' ').filter(Boolean);
  }

  function identityHit(tok, words) {
    return words.indexOf(tok) !== -1;
  }

  function fuzzyHit(tok, words, preferPrefix) {
    var i, w, dist, md, best = null;
    for (i = 0; i < words.length; i++) {
      w = words[i];
      if (w === tok) return { kind: 'exact', d: 0 };
      if (!isFuzzyable(tok) || !isFuzzyable(w)) continue;
      if (w.indexOf(tok) === 0 || tok.indexOf(w) === 0) best = { kind: 'prefix', d: 0 };
    }
    if (best || preferPrefix) return best;
    for (i = 0; i < words.length; i++) {
      w = words[i];
      if (!isFuzzyable(tok) || !isFuzzyable(w)) continue;
      md = Math.min(maxDist(tok), maxDist(w));
      dist = dl(tok, w);
      if (dist <= md && (!best || dist < best.d)) best = { kind: 'fuzzy', d: dist };
    }
    return best;
  }

  function expandYears(y) {
    var s = String(y || '');
    var out = [];
    var seen = {};
    var m, a, b, i, bits, n;
    function add(v) {
      v = String(v);
      if (YEAR_RE.test(v) && !seen[v]) { seen[v] = 1; out.push(v); }
    }
    m = s.match(/(20\d{2})\s*[-–]\s*(present|running)/i);
    if (m) {
      a = parseInt(m[1], 10);
      b = new Date().getFullYear();
      for (i = a; i <= b; i++) add(i);
      return out;
    }
    m = s.match(/(20\d{2})\s*[-–]\s*(20\d{2})/);
    if (m) {
      a = parseInt(m[1], 10);
      b = parseInt(m[2], 10);
      if (b < a) { i = a; a = b; b = i; }
      for (i = a; i <= b; i++) add(i);
      return out;
    }
    bits = s.split(/[^\d]+/);
    for (i = 0; i < bits.length; i++) {
      n = bits[i];
      if (n.length === 4) add(n);
    }
    return out;
  }

  function yearsOf(item) {
    if (item._ys) return item._ys;
    // Product title wins. Handles and collection unions are not fitment facts.
    var title = String(item.t || '');
    var range = title.match(/\b(20(?:1[0-9]|2[0-9]|30))\s*[-–—]\s*(20(?:1[0-9]|2[0-9]|30)|present|running|facelift)\b/i);
    var parenRange = title.match(/\(\s*(20(?:1[0-9]|2[0-9]|30)\s*[-–—]\s*(?:20(?:1[0-9]|2[0-9]|30)|present|running|facelift))\s*\)/i);
    var parenYear = title.match(/\(\s*(20(?:1[0-9]|2[0-9]|30))\s*\)/);
    var single = title.match(/\b20(?:1[0-9]|2[0-9]|30)\b/g);
    var source = parenRange ? parenRange[1] : parenYear ? parenYear[1] : range ? range[0] : single ? single.join(',') : item.my;
    item._yearLabel = String(source || '').replace(/running/ig, 'present').replace(/\s*[-–—]\s*/g, '–').trim();
    item._ys = expandYears(source);
    return item._ys;
  }

  function sizesOf(item) {
    if (item._ss) return item._ss;
    var out = [];
    var seen = {};
    function add(v) {
      v = String(v || '').replace(/[^\d.]/g, '');
      if (v && !seen[v]) { seen[v] = 1; out.push(v); }
    }
    var t = String(item.t || '');
    var re = /(\d{1,2}(?:\.\d{1,2})?)\s*(?:inches\b|inch\b|in\b|″|"|”)/ig;
    var m;
    while ((m = re.exec(t))) add(m[1]);
    item._ss = out;
    return out;
  }

  function yearExplicit(item, years) {
    var blob = String(item.t || '') + ' ' + String(item.y || '');
    var i;
    for (i = 0; i < years.length; i++) {
      if (blob.indexOf(years[i]) !== -1) return true;
    }
    return false;
  }

  function sizeExplicit(item, sizes) {
    var blob = String(item.t || '') + ' ' + String(item.s || '');
    var i;
    for (i = 0; i < sizes.length; i++) {
      if (blob.indexOf(sizes[i]) !== -1) return true;
    }
    return false;
  }

  function yearCovers(item, year) {
    return yearsOf(item).indexOf(String(year)) !== -1;
  }

  function sizeCovers(item, size) {
    var ss = sizesOf(item);
    var i;
    for (i = 0; i < ss.length; i++) {
      if (parseFloat(ss[i]) === parseFloat(size)) return true;
    }
    return false;
  }

  function scoreItem(item, q) {
    var words = hayWords(item);
    var i, hit, kindScore = 0, fuzzy = 0;
    if (!q.words.length && !q.years.length && !q.sizes.length) return null;
    if (!q.words.length) return null;

    for (i = 0; i < q.words.length; i++) {
      var tok = q.words[i];
      if (isIdentity(tok)) {
        if (!identityHit(tok, words)) return null;
        kindScore += 36;
        continue;
      }
      if (isFuzzyable(tok)) {
        hit = fuzzyHit(tok, words, q.prefixWords && q.prefixWords[tok]);
        if (!hit) return null;
        if (hit.kind === 'exact') kindScore += 30;
        else if (hit.kind === 'prefix') kindScore += 20;
        else { kindScore += 8; fuzzy += hit.d; }
        continue;
      }
      if (words.indexOf(tok) === -1) return null;
      kindScore += 24;
    }

    var modelC = compact(item.m || '');
    if (q.compact && modelC && (modelC === q.compact || modelC === compact(q.words.join(' ')))) {
      kindScore += 50;
    }

    return {
      item: item,
      score: kindScore * 10 - fuzzy * 3 + (item.n || 1),
      kindScore: kindScore,
      fuzzy: fuzzy,
      isProduct: !!item.p
    };
  }

  function factsPass(item, q) {
    var i;
    for (i = 0; i < q.years.length; i++) {
      if (!yearCovers(item, q.years[i])) return false;
    }
    for (i = 0; i < q.sizes.length; i++) {
      if (!sizeCovers(item, q.sizes[i])) return false;
    }
    return true;
  }

  function modelKey(item) {
    return String(item.b || '') + '|' + String(item.m || '').replace(/\s+/g, ' ').trim();
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function cleanLabel(m) {
    if (m.p && m.t) {
      var t = String(m.t).replace(/\s*screen guards?\s*/ig, ' ').replace(/\s+/g, ' ').trim();
      return t || m.m;
    }
    var label = String(m.m || '').replace(/\s+/g, ' ').trim();
    if (/^old$/i.test(label) || /^new$/i.test(label)) {
      var src = String(m.t || m.k || label);
      src = src.replace(/screen guards?/ig, '')
        .replace(/\b\d+(\.\d+)?\s*(inch|inches|in|″|")\b/ig, '')
        .replace(/\b(hyundai|mahindra|tata|kia|toyota|maruti suzuki|maruti|honda|bmw|skoda|volkswagen|mg)\b/ig, '')
        .replace(/\bold\b/ig, '')
        .replace(/\s+/g, ' ')
        .trim();
      if (src) label = src;
    }
    label = label.replace(/[“”"]/g, ' ').replace(/\s+/g, ' ').trim();
    return label || m.m;
  }

  function destOf(item) {
    var u = item.u || '';
    if (u.indexOf('/search') === 0) {
      if (item.cu) return item.cu;
    }
    return u;
  }

  function productMeta(item) {
    yearsOf(item);
    return ((item._yearLabel || '') + (sizesOf(item)[0] ? ' · ' + sizesOf(item)[0] + '″' : '')).replace(/^\s·\s/, '') || 'View guard';
  }

  function rowHtml(m, extra, opts) {
    var label = m.p ? cleanLabel(m) : ((m.b ? m.b + ' ' : '') + cleanLabel(m));
    var meta = extra || (m.p ? productMeta(m) : m.n === 1 ? 'View guard' : ((m.n || '') + (m.n ? ' guards' : 'View')));
    var href = destOf(m);
    var cls = (opts && opts.disabled) ? ' aria-disabled="true" tabindex="-1"' : '';
    return '<a href="' + esc(href) + '" role="option"' + cls + '><span><b>' + esc(label) + '</b></span><span class="ag-fb__n">' + esc(meta) + ' →</span></a>';
  }

  function prepareItem(m, isProduct) {
    var name = isProduct && m.t ? m.t : m.m;
    name = String(name || '').replace(/\d+(?:\.\d+)?\s*(?:inches\b|inch\b|in\b|[″"”])/ig, ' ')
      .replace(/\b20(?:1[0-9]|2[0-9]|30)\b/g, ' ');
    var hay = applyPhrases((m.b || '') + ' ' + name);
    return {
      b: m.b, m: m.m, n: m.n, u: m.u, cu: m.cu, t: m.t, y: m.y, s: m.s, a: m.a, my: m.my,
      k: hay, c: compact(hay), p: !!isProduct
    };
  }

  function mergeLive(models, live) {
    var seenU = {};
    var i, m, u;
    for (i = 0; i < models.length; i++) {
      u = destOf(models[i]);
      if (u) seenU[u] = models[i];
    }
    for (i = 0; i < (live || []).length; i++) {
      m = live[i];
      if (!m || !m.m) continue;
      u = m.u || '';
      if (u && seenU[u]) continue;
      /* orchestrator 2026-09-30 (grok review r4 B1): never rewrite a live /search row onto a different collection —
         "Creta Facelift" was relabelled onto the mixed Creta hub (incl. the 2018–2020 Old Creta). Drop such rows: the
         Facelift/Old/EV products exist as their own product records, so they stay findable by their real titles. */
      if (u.indexOf('/search') === 0) continue;
      var item = prepareItem(m, false);
      models.push(item);
      if (item.u) seenU[item.u] = item;
    }
    return models;
  }

  function bootFinder() {
    var root = $('[data-ag-fb]');
    if (!root) return;
    var idxEl = $('[data-fb-idx]');
    if (!idxEl) return;
    var idx;
    try {
      var raw = idxEl.textContent || '';
      var a = raw.indexOf('{');
      var b = raw.lastIndexOf('}');
      idx = JSON.parse(a >= 0 && b > a ? raw.slice(a, b + 1) : raw);
    } catch (e) { return; }
    var LOGOS = {};
    try { LOGOS = JSON.parse(($('[data-fb-logos]') || {}).textContent || '{}'); } catch (e2) {}

    var models = (idx.models || []).map(function (m) { return prepareItem(m, false); });
    var seenProducts = {};
    var products = (idx.products || []).filter(function (p) {
      if (seenProducts[p.u]) return false;
      seenProducts[p.u] = true;
      return true;
    }).map(function (p) { return prepareItem(p, true); });
    models = mergeLive(models, idx.live || []).map(function (m) {
      if (m.u.indexOf('/products/') !== 0) return m;
      var product = products.filter(function (p) { return p.u === m.u; })[0];
      return product ? Object.assign({}, product, { m: m.m }) : m;
    });
    var brands = idx.brands || [];
    var preferBrands = ['Hyundai', 'Mahindra', 'Tata', 'Maruti Suzuki', 'Kia', 'Toyota', 'Honda', 'Volkswagen'];
    var identityWords = models.reduce(function (out, m) {
      return out.concat(applyPhrases((m.b || '') + ' ' + (m.m || '')).split(' '));
    }, []);

    var input = $('[data-fb-input]', root);
    var res = $('[data-fb-results]', root);
    var box = $('[data-fb-box]', root);
    if (!input || !res || !box) return;

    input.setAttribute('aria-controls', 'ag-fb-listbox');
    input.setAttribute('aria-autocomplete', 'list');
    res.id = 'ag-fb-listbox';

    // Reuse the rendered Popular order; product counts are not demand signals.
    var demandOrder = $$('.agm-pop[href]', root).map(function (link) {
      return link.getAttribute('href');
    });
    function demandRank(item) {
      var rank = demandOrder.indexOf(item.cu || destOf(item));
      return rank < 0 ? demandOrder.length : rank;
    }
    function compareHits(a, b) {
      return (a.fuzzy - b.fuzzy) || (b.kindScore - a.kindScore) ||
        (demandRank(a.item) - demandRank(b.item)) || (b.score - a.score);
    }

    var pending = false;
    var lastConfident = false;

    function setStale(on) {
      pending = !!on;
      if (on) {
        res.setAttribute('aria-disabled', 'true');
        res.setAttribute('inert', '');
        res.classList.add('is-stale');
        $$('a', res).forEach(function (el) {
          el.setAttribute('aria-disabled', 'true');
          el.setAttribute('tabindex', '-1');
        });
      } else {
        res.removeAttribute('aria-disabled');
        res.removeAttribute('inert');
        res.classList.remove('is-stale');
      }
    }

    function emptyHtml() {
      var typedWords = applyPhrases(input.value).split(' ');
      var namedBrand = brands.filter(function (br) {
        return applyPhrases(br.b).split(' ').every(function (word) { return typedWords.indexOf(word) !== -1; });
      })[0];
      var brandModels = namedBrand ? modelsFor(namedBrand.b).map(function (m) {
        return '<a href="' + esc(destOf(m)) + '">' + esc(cleanLabel(m)) + '</a>';
      }).join('') : '';
      var brandBits = preferBrands.map(function (name) {
        return brands.filter(function (br) { return br.b === name; })[0];
      }).filter(Boolean).slice(0, 6).map(function (br) {
        if (br.u && br.u.indexOf('/search') !== 0) return '<a href="' + esc(br.u) + '">' + esc(br.b) + '</a>';
        return '<button type="button" data-fb-empty-brand="' + esc(br.b) + '" aria-expanded="false" aria-controls="ag-fb-empty-models">' + esc(br.b) + '</button>';
      }).join('');
      return '<div class="ag-fb__none" role="status">' +
        '<p class="ag-fb__none-title">No exact match for \u2018' + esc(input.value.trim()) + '\u2019</p>' +
        (namedBrand ? '<p>Here are the ' + esc(namedBrand.b) + ' models we have</p>' + brandModels :
          (brandBits ? '<div class="ag-fb__none-brands">' + brandBits + '</div><div id="ag-fb-empty-models" hidden></div>' : '')) +
        '<a class="ag-fb__none-wa" href="' + WA + '" target="_blank" rel="noopener">Ask us on WhatsApp with your car model</a>' +
        '<a class="ag-fb__none-all" href="/search?q=' + encodeURIComponent(input.value.trim()) + '">Search all products</a>' +
        '</div>';
    }

    function uniqueRows(list, n) {
      var seen = {};
      var out = [];
      var i, it, key;
      for (i = 0; i < list.length && out.length < n; i++) {
        it = list[i].item;
        key = destOf(it);
        if (seen[key]) continue;
        seen[key] = 1;
        out.push(list[i]);
      }
      return out;
    }

    function search(typed) {
      var q = parseQuery(typed);
      lastConfident = false;
      if (norm(typed).length < 2) {
        res.hidden = true;
        box.setAttribute('aria-expanded', 'false');
        setStale(false);
        return;
      }
      if (!q.words.length) {
        res.innerHTML = emptyHtml();
        res.hidden = false;
        setStale(false);
        return;
      }
      // Real model/brand prefixes take precedence over spelling corrections.
      q.prefixWords = {};
      q.words.forEach(function (tok) {
        q.prefixWords[tok] = isFuzzyable(tok) && identityWords.some(function (word) {
          return word === tok || (isFuzzyable(word) && word.indexOf(tok) === 0);
        });
      });
      if (q.decimals.length) {
        var decimalIdentity = Object.assign({}, q, { words: q.words.concat(q.decimals) });
        var fullDecimal = models.concat(products).some(function (p) { return scoreItem(p, decimalIdentity); });
        if (!fullDecimal && models.concat(products).some(function (p) { return scoreItem(p, q); })) {
          q.sizes = q.sizes.concat(q.decimals);
        } else q.words = decimalIdentity.words;
      }
      // A leftover short integer is a size only when the full identity fails.
      // Sealion 7, 3 Series and XUV 700 therefore keep their model numbers.
      var tail = q.words[q.words.length - 1];
      if (/^\d{1,2}$/.test(tail) && q.words.length > 1) {
        var base = Object.assign({}, q, { words: q.words.slice(0, -1) });
        var fullIdentity = models.concat(products).some(function (p) { return scoreItem(p, q); });
        if (!fullIdentity && models.concat(products).some(function (p) { return scoreItem(p, base); })) {
          q.words = base.words;
          q.sizes.push(tail);
          q.modelLabel = q.modelLabel.replace(/\s+\d{1,2}$/, '').trim();
        }
      }
      var i, s;
      var modelHits = [];
      var productHits = [];
      for (i = 0; i < models.length; i++) {
        s = scoreItem(models[i], q);
        if (s) modelHits.push(s);
      }
      for (i = 0; i < products.length; i++) {
        s = scoreItem(products[i], q);
        if (s) productHits.push(s);
      }
      modelHits.sort(compareHits);
      productHits.sort(function (a, b) { return (a.fuzzy - b.fuzzy) || (b.score - a.score); });

      if (!modelHits.length && !productHits.length) {
        res.innerHTML = emptyHtml();
        res.hidden = false;
        box.setAttribute('aria-expanded', 'true');
        setStale(false);
        lastConfident = false;
        return;
      }

      var filteredP = productHits;
      var filteredM = modelHits;
      var yearMiss = false;
      if (q.years.length || q.sizes.length) {
        filteredP = productHits.filter(function (h) { return factsPass(h.item, q); });
        // Filtered searches navigate only to products with verified facts.
        filteredM = [];
        if (!filteredP.length && !filteredM.length) {
          yearMiss = true;
        }
      }

      if (yearMiss) {
        var modelLabel = q.modelLabel;
        var yearOnly = Object.assign({}, q, { sizes: [] });
        var yearGuards = productHits.filter(function (h) { return factsPass(h.item, yearOnly); });
        var sizeMiss = q.sizes.length && yearGuards.length;
        var guards = (sizeMiss ? yearGuards : productHits).slice().sort(function (a, b) {
          var ae = yearExplicit(a.item, q.years), be = yearExplicit(b.item, q.years);
          return (ae !== be ? (ae ? -1 : 1) : 0) || (a.fuzzy - b.fuzzy) || (b.score - a.score);
        });
        var message;
        if (sizeMiss) {
          message = 'No ' + q.sizes.join(' / ') + '″ ' + modelLabel + ' guard' +
            (q.years.length ? ' for ' + q.years.join(', ') : '') +
            ' — here are the ' + (q.years.length ? q.years.join(', ') + ' ' : '') + modelLabel + ' guards';
        } else {
          message = 'No ' + modelLabel + ' guard' + (q.years.length ? ' for ' + q.years.join(', ') : '') +
            (q.sizes.length ? ' with a ' + q.sizes.join(' / ') + '″ screen' : '') +
            ' — here are the ' + modelLabel + ' guards we have';
        }
        var rows = uniqueRows(guards, 8).map(function (h) { return rowHtml(h.item); }).join('');
        res.innerHTML = '<div class="ag-fb__none" role="status"><p class="ag-fb__none-title">' +
          esc(message) + '</p>' + rows +
          '<a href="' + WA + '" rel="noopener">Ask us on WhatsApp with your car model</a></div>';
        res.hidden = false;
        box.setAttribute('aria-expanded', 'true');
        setStale(false);
        lastConfident = false;
        return;
      }

      var merged = filteredP.concat(filteredM);
      merged.sort(function (a, b) {
        if (q.years.length || q.sizes.length) {
          if (a.isProduct !== b.isProduct) return a.isProduct ? -1 : 1;
          var ae = yearExplicit(a.item, q.years);
          var be = yearExplicit(b.item, q.years);
          if (ae !== be) return ae ? -1 : 1;
          var asz = sizeExplicit(a.item, q.sizes);
          var bsz = sizeExplicit(b.item, q.sizes);
          if (asz !== bsz) return asz ? -1 : 1;
        }
        return compareHits(a, b);
      });
      var out = uniqueRows(merged, 8);
      res.innerHTML = out.map(function (h) {
        var extra = h.item.p
          ? productMeta(h.item)
          : (h.item.n === 1 ? 'View guard' : (h.item.n + ' guards'));
        return rowHtml(h.item, extra);
      }).join('');
      res.hidden = false;
      box.setAttribute('aria-expanded', 'true');
      setStale(false);
      lastConfident = out.length > 0;
    }

    var t;
    function saveQuery() {
      var url = new URL(window.location.href);
      if (input.value) url.searchParams.set('q', input.value);
      else url.searchParams.delete('q');
      if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url.href);
    }
    function restoreQuery() {
      clearTimeout(t);
      input.value = new URL(window.location.href).searchParams.get('q') || '';
      search(input.value);
    }
    window.addEventListener('pageshow', restoreQuery);
    restoreQuery();
    input.addEventListener('input', function () {
      saveQuery();
      clearTimeout(t);
      setStale(true);
      lastConfident = false;
      t = setTimeout(function () { search(input.value); }, 120);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      if (pending) return;
      if (!lastConfident) return;
      var a = res.querySelector('a[role="option"]:not([aria-disabled="true"])');
      if (a && !res.hidden && a.getAttribute('href')) {
        location.href = a.getAttribute('href');
      }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) res.hidden = true;
    });
    res.addEventListener('click', function (e) {
      var brandBtn = e.target.closest('[data-fb-empty-brand]');
      if (brandBtn && !pending) {
        var panel = $('#ag-fb-empty-models', res);
        if (panel) {
          panel.innerHTML = chipHtml(modelsFor(brandBtn.getAttribute('data-fb-empty-brand')), '', '');
          panel.hidden = false;
          brandBtn.setAttribute('aria-expanded', 'true');
        }
      }
      if (res.classList.contains('is-stale')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    var HUES = [214, 25, 152, 262, 340, 196, 45, 286, 10, 170, 230, 60];
    function art(name, i) {
      if (LOGOS[name]) return '<img class="agm-logo" src="' + LOGOS[name] + '" alt="" width="40" height="40" loading="lazy">';
      var parts = String(name).split(/\s+/);
      var ini = (parts[0][0] + (parts[1] ? parts[1][0] : '')).toUpperCase();
      return '<span class="ag-fb__mono" style="background:hsl(' + HUES[i % HUES.length] + ',48%,42%)">' + esc(ini) + '</span>';
    }

    function fillLogo(btn, i) {
      var slot = btn.querySelector('.ag-fb__logo-slot');
      if (!slot || slot.getAttribute('data-filled')) return;
      slot.setAttribute('data-filled', '1');
      /* Liquid already printed the logo. Never replace or duplicate that img. */
      if (slot.querySelector('img')) return;
      var name = btn.getAttribute('data-fb-brand');
      slot.innerHTML = art(name, i);
    }

    function modelsFor(brand) {
      var seen = {};
      return models.filter(function (m) {
        var label = String(m.m || '');
        var u = destOf(m);
        if (seen[u]) return false;
        if (m.b === brand) seen[u] = true;
        return m.b === brand &&
          !/^old$/i.test(label) && !/^new$/i.test(label) &&
          u.indexOf('/search') !== 0;
      });
    }

    function chipHtml(list, brandUrl, brandName) {
      var html = list.map(function (m) {
        return '<a href="' + esc(destOf(m)) + '">' + esc(cleanLabel(m)) + '</a>';
      }).join('');
      if (brandUrl && brandUrl.indexOf('/search') !== 0 && brandUrl.indexOf('/collections/') === 0) {
        html += '<a class="ag-fb__all" href="' + esc(brandUrl) + '">All ' + esc(brandName) + ' →</a>';
      }
      return html;
    }

    var bhost = $('[data-fb-brands]', root);
    var EXCLUDE = { Ather: 1, Ola: 1, KTM: 1 };
    brands = brands.filter(function (br) { return !EXCLUDE[br.b]; });

    if (bhost) {
      $$('[data-fb-brand]', bhost).forEach(fillLogo);
      if (!bhost.children.length) {
        bhost.innerHTML = brands.map(function (br, i) {
          return '<button type="button" class="ag-fb__brand" data-fb-brand="' + esc(br.b) +
            '" aria-expanded="false" aria-controls="ag-fb-grid-panel">' +
            '<span class="ag-fb__logo-slot ag-fb__logo-slot--lg" aria-hidden="true">' + art(br.b, i) + '</span>' +
            '<span>' + esc(br.b) + '</span></button>';
        }).join('');
      }
    }

    var railPanel = $('[data-fb-rail-panel]', root);
    var gridPanel = $('[data-fb-grid-panel]', root);
    var openBtn = null;

    function closePanel() {
      if (openBtn) {
        openBtn.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn = null;
      }
      if (railPanel) { railPanel.hidden = true; railPanel.innerHTML = ''; }
      if (gridPanel) { gridPanel.hidden = true; gridPanel.innerHTML = ''; }
    }

    /* 2026-10-05: open the grid panel directly under the tapped tile's row (grid-column 1/-1).
       One shared panel after all brand tiles put the models ~400px below a phone screen, so a
       tap looked dead. Call only while the panel is hidden, so it adds no row to the layout read. */
    function placeGridPanel(btn) {
      if (!bhost || !gridPanel || btn.parentNode !== bhost) return;
      var top = btn.getBoundingClientRect().top;
      var last = btn;
      $$('[data-fb-brand]', bhost).forEach(function (t) {
        if (Math.abs(t.getBoundingClientRect().top - top) < 2) last = t;
      });
      if (last.nextSibling !== gridPanel) bhost.insertBefore(gridPanel, last.nextSibling);
    }

    /* If the first models would sit under the bottom tab bar (or below the screen), scroll just enough to show them. */
    function revealPanel(panel) {
      var bar = document.querySelector('.ag-tabbar-shell');
      var barTop = bar ? bar.getBoundingClientRect().top : 0;
      var bottom = barTop > 0 && barTop < window.innerHeight ? barTop : window.innerHeight;
      var need = panel.getBoundingClientRect().top + 120 - bottom;
      if (need <= 0) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce && 'scrollBehavior' in document.documentElement.style) window.scrollBy({ top: need, behavior: 'smooth' });
      else window.scrollBy(0, need);
    }

    /* Rotation / resize changes the column count: re-place an open grid panel so it never splits a row. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!openBtn || !gridPanel || gridPanel.hidden || openBtn.parentNode !== bhost) return;
        gridPanel.hidden = true;
        placeGridPanel(openBtn);
        gridPanel.hidden = false;
      }, 150);
    });

    function toggleBrand(btn, brandName) {
      var br = brands.filter(function (x) { return x.b === brandName; })[0];
      if (!br) return;
      if (openBtn === btn) { closePanel(); return; }
      /* Closing a tall open panel above this tile moves the tile up; browsers without scroll
         anchoring (older iOS Safari) would leave it and its new panel off-screen. Keep it put.
         Native anchoring is paused for this swap so Chrome does not correct a second time. */
      var tileTop = btn.getBoundingClientRect().top;
      var de = document.documentElement, bd = document.body;
      var anchorWas = [de.style.overflowAnchor, bd.style.overflowAnchor];
      de.style.overflowAnchor = 'none'; bd.style.overflowAnchor = 'none';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        de.style.overflowAnchor = anchorWas[0]; bd.style.overflowAnchor = anchorWas[1];
      }); });
      closePanel();
      openBtn = btn;
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var list = modelsFor(br.b);
      var isRail = btn.classList.contains('ag-fb__bchip');
      var panel = isRail ? railPanel : gridPanel;
      if (!panel) return;
      btn.setAttribute('aria-controls', panel.id || (isRail ? 'ag-fb-rail-panel' : 'ag-fb-grid-panel'));
      if (!isRail) placeGridPanel(btn);
      panel.innerHTML = chipHtml(list, br.u, br.b);
      panel.hidden = false;
      var shift = btn.getBoundingClientRect().top - tileTop;
      if (Math.abs(shift) > 1) window.scrollBy(0, shift);
      revealPanel(panel);
    }

    if (bhost && !bhost.__agP30) {
      bhost.__agP30 = true;
      bhost.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fb-brand]');
        if (!btn) return;
        toggleBrand(btn, btn.getAttribute('data-fb-brand'));
      });
    }

    var rail = $('[data-fb-brandrail]', root);
    if (rail) {
      $$('[data-fb-brand]', rail).forEach(fillLogo);
      if (!rail.children.length) {
        var prefer = ['Hyundai', 'Mahindra', 'Tata', 'Maruti Suzuki', 'Kia', 'Toyota', 'Honda', 'Volkswagen'];
        var ordered = prefer.map(function (n) {
          return brands.filter(function (br) { return br.b === n; })[0];
        }).filter(Boolean).concat(brands.filter(function (br) { return prefer.indexOf(br.b) === -1; }));
        rail.innerHTML = ordered.map(function (br, i) {
          return '<button type="button" class="ag-fb__bchip" data-fb-brand="' + esc(br.b) +
            '" aria-expanded="false" aria-controls="ag-fb-rail-panel">' +
            '<span class="ag-fb__logo-slot" aria-hidden="true">' + art(br.b, i) + '</span>' +
            '<span>' + esc(br.b) + '</span></button>';
        }).join('');
      }
    }
    if (rail && !rail.__agP30) {
      rail.__agP30 = true;
      rail.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fb-brand]');
        if (!btn) return;
        toggleBrand(btn, btn.getAttribute('data-fb-brand'));
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootFinder);
  else bootFinder();
})();
